<!-- Modern Mobile Bottom Navigation 2025 -->
<div class="modern-bottom-nav" role="navigation" aria-label="Primary Navigation">
    <div class="bottom-nav-surface">
        <!-- Navigation Container -->
        <div class="bottom-nav-container">
            @for (item of mainNavItems; track $index) {
            <button type="button" class="nav-item" [ngClass]="{'nav-item-active': isItemActive(item.path)}"
                [routerLink]="item.path" [attr.aria-label]="'Navigate to ' + item.name"
                [attr.aria-current]="isItemActive(item.path) ? 'page' : null">

                <div class="nav-icon-container">
                    <div class="nav-icon" [ngClass]="{'nav-icon-active': isItemActive(item.path)}">
                        @if (item.icon) {
                        <lucide-icon [name]="item.icon" size="22" class="nav-lucide-icon"
                            aria-hidden="true"></lucide-icon>
                        }
                        @if (item.badge) {
                        <span class="nav-badge" role="status" [attr.aria-label]="item.badge + ' notifications'">
                            {{ item.badge }}
                        </span>
                        }
                    </div>
                </div>

                <span class="nav-label" [ngClass]="{'nav-label-active': isItemActive(item.path)}">
                    {{ item.name }}
                </span>
            </button>
            }

            <!-- More Menu Button -->
            <button type="button" class="nav-item nav-more" [ngClass]="{'nav-item-active': isMoreActive}"
                (click)="toggleMoreMenu()" aria-haspopup="dialog" [attr.aria-expanded]="showMoreMenu">
                <div class="nav-icon-container">
                    <div class="nav-icon" [ngClass]="{'nav-icon-active': isMoreActive}">
                        <lucide-icon [name]="showMoreMenu ? 'x' : 'layout-grid'" size="20"
                            class="nav-lucide-icon"></lucide-icon>
                        
                    </div>
                </div>
                <span class="nav-label" [ngClass]="{'nav-label-active': isMoreActive}">More</span>
            </button>
        </div>
    </div>

    <!-- Safe Area for iOS devices -->
    <div class="bottom-safe-area"></div>
</div>

<!-- More Menu Drawer -->
@if (showMoreMenu) {
<nz-drawer [nzVisible]="true" nzPlacement="bottom" (nzOnClose)="closeMoreMenu()" [nzClosable]="true"
    [nzBodyStyle]="{ padding: '0' }" nzWrapClassName="modern-more-menu-drawer" [nzHeight]="'auto'">
    <ng-container *nzDrawerContent>
        <!-- Drawer Handle -->
        <div class="drawer-handle-bar"></div>

        <!-- Drawer Header -->
        <div class="drawer-header-section">
            <div class="drawer-header-content">
                <h3 class="drawer-title">All features</h3>
                <p class="drawer-subtitle">Grow, engage, and connect — same as desktop</p>
            </div>
        </div>

        <!-- Drawer Body -->
        <div class="drawer-body-section">
            @for (section of moreMenuSections; track section.label) {
            <div class="drawer-menu-section">
                <p class="or-nav-group-label drawer-section-label">{{ section.label }}</p>
                <div class="drawer-menu-grid">
                    @for (item of section.items; track item.path) {
                    @let moreItem = getMoreMenuItem(item);
                    <button type="button" class="drawer-menu-card"
                        [ngClass]="{'drawer-menu-card-active': isItemActive(moreItem.path)}" [routerLink]="moreItem.path"
                        (click)="closeMoreMenu()" [attr.aria-label]="moreItem.name">

                        <div class="drawer-card-icon-wrapper">
                            <div class="drawer-card-icon">
                                @if (moreItem.icon) {
                                <lucide-icon [name]="moreItem.icon" size="22" class="drawer-card-lucide-icon"
                                    aria-hidden="true"></lucide-icon>
                                }
                            </div>
                        </div>

                        <div class="drawer-card-content">
                            <span class="drawer-card-title"
                                [ngClass]="{'drawer-card-title-active': isItemActive(moreItem.path)}">
                                {{ moreItem.name }}
                            </span>
                            @if (moreItem.description) {
                            <span class="drawer-card-desc">{{ moreItem.description }}</span>
                            }
                        </div>

                        <div class="drawer-card-arrow">
                            <lucide-icon name="chevron-right" size="14"></lucide-icon>
                        </div>
                    </button>
                    }
                </div>
            </div>
            }
        </div>

        <!-- Safe Area for iOS -->
        <div class="drawer-safe-area"></div>
    </ng-container>
</nz-drawer>
}